/* eslint import/no-extraneous-dependencies: 0 */
// 'bootstrap' is aliased to 'bootstrap-sass'

import 'bootstrap';

export function presentModal($el, options) {
  return $el.modal(options);
}

export function closeModal($el) {
  return $el.modal('hide');
}



// WEBPACK FOOTER //
// ./utils/modal.js